<div class="row mb-2">
  <!-- <div class="col-md-2">
    <select [(ngModel)]="searchBy" class="form-control">
      <option value="">Select Search By</option>
      <option value="packageID">Package ID</option>
      <option value="userId">User ID</option>
      <option value="senderMobile">Sender Mobile no</option>
      <option value="senderName">Sender Name</option>
      <option value="fromAddress">From Address</option>
    </select>
  </div>
  <div class="col-md-2">
    <input
      type="search"
      [(ngModel)]="searchText"
      class="form-control mb-2"
      placeholder="Search Text"
    />
  </div>
  <div class="col-md-2">
    <button
      (click)="search()"
      class="btn btn-primary btn-block"
      [disabled]="searchBy == ''"
    >
      Search <i class="fa fa-search"></i>
    </button>
  </div> -->

  <!-- <div class="col-md-6 m-0 text-end">
    <button
      (click)="exportToExcel()"
      style="margin-right: 5px !important"
      class="btn-shadow d-inline-flex align-items-center btn btn-success"
    >
      <i class="fa fa-file-excel-o" aria-hidden="true"></i> Export Current Excel
    </button>
    <button
      (click)="getAllPackagess()"
      class="btn-shadow d-inline-flex align-items-center btn btn-success"
    >
      <i class="fa fa-file-excel-o" aria-hidden="true"></i> Export All Excel
    </button>
  </div> -->
</div>

<div class="main-card mb-3 card">
  <!-- <div class="card-header font-weight-B fs-1r">All Loads</div> -->

  <div
    class="card-header d-flex justify-content-between align-items-center font-weight-bold fs-1r"
  >
    <span>All User Loads</span>
    <button class="btn btn-primary btn-sm" routerLink="/dashboard/post-load">
      + Post Load
    </button>
  </div>

  <div class="table-responsive">
    <table
      class="align-middle mb-0 table table-borderless table-striped table-hover"
      id="excel-table"
    >
      <thead>
        <tr class="align-middle">
          <th>From</th>
          <th>To</th>
          <th>User Name</th>
          <th>Phone No</th>
          <th>Product Type</th>
          <th>Product</th>
          <th>Amount (RS)</th>
          <th>Advance</th>
          <th>Created On</th>
          <th class="text-end">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr
          *ngFor="
            let data of allPosts
              | paginate
                : {
                    itemsPerPage: itemsPerPage,
                    currentPage: page,
                    totalItems: totalItems
                  }
          "
        >
          <!-- <td class="text-left text-muted">#355</td> -->
          <td>
            <div class="widget-content p-0">
              <div class="widget-content-wrapper">
                <div class="widget-content-left flex2">
                  <div class="widget-heading">
                    {{ data.pickupLocationCity }},
                    {{ data.pickupLocationState }},
                    {{ data.pickupLocationCountry }}
                  </div>
                  <!-- <div class="widget-subheading opacity-7">Web Developer</div> -->
                </div>
              </div>
            </div>
          </td>

          <td>
            <div class="widget-content p-0">
              <div class="widget-content-wrapper">
                <div class="widget-content-left flex2">
                  <div class="widget-heading">
                    {{ data.dropLocationCity }}, {{ data.dropLocationState }},
                    {{ data.dropLocationCountry }}
                  </div>
                  <!-- <div class="widget-subheading opacity-7">Web Developer</div> -->
                </div>
              </div>
            </div>
          </td>

          <!-- <td>
            <div class="widget-content p-0">
              <div class="widget-content-wrapper">
                <div class="widget-content-left flex2">
                  <div class="widget-heading">
                    {{ data.userDetails?.firstName }}
                    {{ data.userDetails?.lastName }}
                  </div>
                </div>
              </div>
            </div>
          </td>
          <td>
            <div class="widget-content p-0">
              <div class="widget-content-wrapper">
                <div class="widget-content-left flex2">
                  <div class="widget-heading">
                    {{ data.userDetails?.phoneNumber }}
                  </div>
                </div>
              </div>
            </div>
          </td> -->
          <td>
            <div class="widget-content p-0">
              <div class="widget-content-wrapper">
                <div class="widget-content-left flex2">
                  <div class="widget-heading">
                    <ng-container *ngIf="data.isAdminPosted; else userName">
                      Admin Posted
                    </ng-container>
                    <ng-template #userName>
                      {{ data.userDetails?.firstName }}
                      {{ data.userDetails?.lastName }}
                    </ng-template>
                  </div>
                </div>
              </div>
            </div>
          </td>

          <td>
            <div class="widget-content p-0">
              <div class="widget-content-wrapper">
                <div class="widget-content-left flex2">
                  <div class="widget-heading">
                    <ng-container *ngIf="data.isAdminPosted; else userPhone">
                      Admin Posted
                    </ng-container>
                    <ng-template #userPhone>
                      {{ data.userDetails?.phoneNumber }}
                    </ng-template>
                  </div>
                </div>
              </div>
            </div>
          </td>

          <td>
            <div class="widget-content p-0">
              <div class="widget-content-wrapper">
                <div class="widget-content-left flex2">
                  <div class="widget-heading">{{ data.productType }}</div>
                  <!-- <div class="widget-subheading opacity-7">Web Developer</div> -->
                </div>
              </div>
            </div>
          </td>
          <td>
            <div class="widget-content p-0">
              <div class="widget-content-wrapper">
                <div class="widget-content-left flex2">
                  <div class="widget-heading">{{ data.product }}</div>
                </div>
              </div>
            </div>
          </td>
          <td>
            <div class="widget-content p-0">
              <div class="widget-content-wrapper">
                <div class="widget-content-left flex2">
                  <div class="widget-heading">{{ data.amount }}</div>
                </div>
              </div>
            </div>
          </td>
          <td>
            <div class="widget-content p-0">
              <div class="widget-content-wrapper">
                <div class="widget-content-left flex2">
                  <div class="widget-heading">{{ data.advance }}</div>
                </div>
              </div>
            </div>
          </td>
          <td>
            <div class="widget-content p-0">
              <div class="widget-content-wrapper">
                <div class="widget-content-left flex2">
                  <div class="widget-heading">
                    {{ data.createdAt | date: "dd MMM yyyy hh:mm a" : "en-IN" }}
                  </div>
                </div>
              </div>
            </div>
          </td>

          <td class="text-end">
            <div class="dropdown">
              <button
                class="btn btn-info dropdown-toggle"
                type="button"
                id="dropdownMenuButton1"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                Action
              </button>
              <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                <li>
                  <a class="dropdown-item" (click)="viewLoad(data)"
                    >View Load <i class="fa fa-gavel"></i
                  ></a>
                </li>
                <li>
                  <a class="dropdown-item" (click)="viewBids(data)"
                    >View Bids <i class="fa fa-gavel"></i
                  ></a>
                </li>
                <li>
                  <a class="dropdown-item" (click)="deleteData(data)"
                    >Delete <i class="fa fa-trash"></i
                  ></a>
                </li>
              </ul>
            </div>
          </td>
        </tr>
      </tbody>
      <div *ngIf="allPosts?.length == 0" class="text-center mt-5 mb-5">
        <span class="text-danger">Data Not found</span>
      </div>
    </table>
    <!-- <pagination-controls class="my-pagination" (pageChange)="gty((page = $event))"></pagination-controls> -->

    <ngb-pagination
      (pageChange)="getAllUserPosts((page = $event))"
      [collectionSize]="totalItems"
      [(page)]="page"
      [pageSize]="itemsPerPage"
      [maxSize]="3"
      [rotate]="true"
      [boundaryLinks]="false"
    >
    </ngb-pagination>
  </div>
</div>
